import { useSelector, useDispatch } from "react-redux";
import { Dispatch } from "redux";
import { ErrorAction, ErrorDetail } from "../reducers/errorReducer";
import { ActionTypeCommon, StoreTypeCommon } from "../index";

export interface ErrorAction_Set extends ActionTypeCommon {
  type: ErrorAction.ERROR;
  payload: {
    // error object {name, detail}
    name: string;
    error: ErrorDetail;
  };
}

export interface ErrorAction_Clear extends ActionTypeCommon {
  type: ErrorAction.ERROR_CLEAR;
  payload: string; // error name
}

export type ErrorActionType = ErrorAction_Set | ErrorAction_Clear;

export enum ErrorType {
  NONE = "NONE",
  CONNECTION_ERROR = "CONNECTION_ERROR",
  APP_ERROR = "APP_ERROR",
}

// get out the error if there have then clear it
export const useErrorChecker = (errorName: string): ErrorDetail | null => {
  const error = useSelector<StoreTypeCommon, ErrorDetail>((state) => state.error[errorName]);
  const dispatch = useDispatch<Dispatch<ErrorActionType>>();
  if (error && error.errorType !== ErrorType.NONE) {
    const catchError = { ...error };
    dispatch({
      type: ErrorAction.ERROR_CLEAR,
      payload: errorName,
    });
    return catchError;
  }
  return null;
};
